import type { FormEvent, ReactNode } from "react";
import Button from "ui/buttons/Button";
import Modal from "ui/components/Modal";
import styles from "./ArchivePlanModal.module.scss";

interface ArchivePlanModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (e: FormEvent<HTMLFormElement>) => Promise<void> | void;
  planDetail: string;
  planName?: string | null;
  message?: ReactNode;
  isArchiving?: boolean;
  isUnarchive?: boolean;
}

export default function ArchivePlanModal({
  open,
  onClose,
  onConfirm,
  planDetail,
  planName,
  message,
  isArchiving = false,
  isUnarchive = false,
}: ArchivePlanModalProps) {
  const action = isUnarchive ? "Unarchive" : "Archive";
  const actionLower = isUnarchive ? "unarchive" : "archive";
  const actionProgress = isUnarchive ? "Unarchiving..." : "Archiving...";

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="small"
      title={`${action} Plan`}
      footer={
        <>
          <Button btnSize="large" type="button" btnStyle="tertiary" onClick={onClose}>
            Cancel
          </Button>
          <form onSubmit={onConfirm}>
            <Button btnSize="large" type="submit" disabled={isArchiving}>
              {isArchiving ? actionProgress : action}
            </Button>
          </form>
        </>
      }
      variants={["bodyPadding", "footerButtons"]}
    >
      <div className={styles.wrapper}>
        <p className={styles.question}>
          Are you sure you want to {actionLower} the {planDetail}
          {planName ? ` "${planName}"` : ""}?
        </p>
        {message && <div className={styles.message}>{message}</div>}
      </div>
    </Modal>
  );
}
